export const validateAllPositionsMatch = (elementCurrentDirection, _, elementsCurrentDirections) => {
  return elementCurrentDirection.position === elementsCurrentDirections[0].position;
};

export const validateAllDirectionsMatch = (elementCurrentDirection, _, elementsCurrentDirections) => {
  return elementCurrentDirection.direction === elementsCurrentDirections[0].direction;
};
